import {
  AfterContentChecked,
  Component,
  ChangeDetectorRef,
  HostListener,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "src/app/core/services/shared/api.service";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import { CommonHandlerService } from "src/app/core/services/shared/common-handler.service";
import { EncryptDecreptService } from "src/app/core/services/shared/encrypt-decrept.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";

import {
  Answer,
  CodehelpService,
  CollegeData,
  ConfigMapService,
  FieldInfo,
  FormData,
  FormResponse,
  InputType,
  NpcCalculation,
  Page,
  Question,
  Searchconfig,
} from "virtue-form";

@Component({
  selector: "app-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.css"],
})
export class StepperComponent implements OnInit, AfterContentChecked {
  // drag file

  dragAreaClass: string | undefined;
  onFileChange(event: any) {
    let files: FileList = event.target.files;
    this.saveFiles(files);
  }
  //

  isInternatinalStudent: boolean = false;
  filledId = "";
  opdata: any;
  pageData!: Page;
  formData!: FormData;
  errorMessage: Array<string> = [];
  answerMap: Map<Number, Answer> = new Map();
  disableMap: Map<Number, boolean> = new Map();
  pageHeaderQuestion: Question | undefined;
  calculatedFilledbyinfoArray: Array<Question> = [];
  totalpage = 2;
  extrPage = 0;

  defaultValues: string = "0";
  isLoading: boolean = false;
  calculatedData!: NpcCalculation;
  showError = false;
  activeTabIndex = 0;
  apiCall = false;
  showData = true;
  logoUrl: string | undefined;
  homedata!: CollegeData;
  saveChangeDeduct: boolean = true;
  isValid: boolean = false;
  isShowComparePage: boolean = false;
  currentpage = 1;
  validated: FieldInfo | undefined;
  baseurl: string = "";

  extraData: any = "";
  basePath = "";
  constructor(
    private apiService: ApiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private configmap: ConfigMapService,
    private checkUserLogin: CheckLoginSessionService,
    private router: Router,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService,
    private common: CommonHandlerService,
    private EncryptDecrpt: EncryptDecreptService
  ) {
    this.answerMap = this.globalvar.answerMap;
    this.basePath = this.globalvar.basepath;
  }
  sectionTitle = "Profile";
  setHeadercontainer: number = 1;
  ngOnInit() {
    this.baseurl = "top5";
    this.getProductKey();
    if (
      this.globalvar.myAccountPageUrl == "/home/Accounts" ||
      this.globalvar.myAccountPageUrl == undefined
    ) {
      // this.spinnerService.show();
      this.getPageData();
    }
    this.globalvar.pageChange.subscribe((stepper) => {
      this.currentpage = stepper.page;
      console.log(this.currentpage, "CurrentPage");

      this.getPageData();
    });

    this.activatedRoute.params.subscribe((params) => {
      this.globalvar.organizationLoaded.subscribe((value: boolean) => {
        if (this.globalvar.isOrgLoaded == true) {
          if (value && value != undefined) {
            this.globalvar.isOrgLoaded = false;
            if (this.globalvar.serviceConfig?.extraData) {
              this.extraData = JSON.parse(
                this.globalvar.serviceConfig?.extraData
              );
            }
            // this.getPageData();
            if (
              this.globalvar.top5SubscriptionDashboardRequestData != undefined
            ) {
              if (
                this.globalvar.top5SubscriptionDashboardRequestData
                  ?.top5_request == true
              ) {
                this.isShowComparePage = true;
                this.currentpage = Number(params.page);

                if (
                  this.globalvar.top5SubscriptionDashboardRequestData
                    ?.internationalStudent != undefined
                ) {
                  this.isInternatinalStudent =
                    this.globalvar.top5SubscriptionDashboardRequestData?.internationalStudent;
                  this.globalvar.isInternatinalStudent =
                    this.globalvar.top5SubscriptionDashboardRequestData?.internationalStudent;
                } else {
                  this.isInternatinalStudent = false;
                  this.globalvar.isInternatinalStudent = false;
                }
              }
            }
            if (
              this.globalvar.seFormFilledId &&
              this.globalvar.seFormFilledId != ""
            ) {
              this.getAnswerMapFromID(this.globalvar.seFormFilledId);
              // this.globalvar.seFormFilledId = params.formfilledid;
              this.globalvar.change(Number(this.currentpage));
            } else {
              if (this.globalvar.formId != "") {
                const profile = JSON.parse(this.codehelp.getUserProfile());
                if (profile != undefined && profile != null) {
                  const userProfile = JSON.parse(
                    this.codehelp.getUserProfile()
                  );
                  if (
                    profile?.type == "STUDENT" ||
                    profile?.type == "ADMIN" ||
                    profile?.type == "COUNSELOR" ||
                    userProfile?.mappedTo?.id
                  ) {
                    // if ((login == "DemoStudent" || profile?.type=="STUDENT") && a == "true") { (login == "DemoStudent" && login == "UserLogin") ||
                    this.SubmissionRegistrebyStudent(userProfile, value);
                  } else {
                    this.globalvar.redirectPage(
                      this.currentpage,
                      true,
                      false,
                      true
                    );
                  }
                }
              }
            }
          }
        }
      });
    });
  }

  getProductKey() {
    this.apiService.getProductKeyontool((res: any) => {
      if (res) {
        this.globalvar.ProductKey = res.productId;
        this.apiService.getpriceList(res.productId).then((resp: any) => {
          this.globalvar.PriceList = resp;
          console.log(this.globalvar.PriceList);
        });
      }
    });
  }

  SubmissionRegistrebyStudent(userProfile: any, loadOrganization: boolean) {
    this.spinnerService.show();
    this.isLoading = true;
    this.apiService.getRegistredSubmissionCallBackList(
      userProfile.id,
      (resp: any) => {
        if (resp) {
          if (resp.length > 0) {
            let answers = resp[0].answers;
            let formFilledId = resp[0].id;
            this.globalvar.formSubmitId = formFilledId;
            this.globalvar.formResponse = resp[0];
            answers.forEach((element) => {
              if (element?.configId != "high_school") {
                this.setConfigOptions(element?.configId, element?.fieldNo);
              }
              this.changeWidgetInput(element);
            });
            this.apiService.getFormData((response: FormData) => {
              this.globalvar.formReqData = response;
              this.apiService.formData = response;
              this.pageResponseData(response);
              this.getSubmissionsDataBYSubmittedId(
                answers,
                formFilledId,
                loadOrganization
              );
            });
          } else {
            this.isLoading = false;
            this.apiService.getFormData((response: FormData) => {
              response.filledByInfos.forEach((element) => {
                if (element.fieldNo == 1)
                  this.AddAnswer(
                    element.fieldNo,
                    userProfile.firstName,
                    element.display.inputType,
                    element.display.label,
                    0,
                    "",
                    element.conditionFieldNo,
                    element.configId
                  );

                if (element.fieldNo == 2)
                  this.AddAnswer(
                    element.fieldNo,
                    userProfile.lastName,
                    element.display.inputType,
                    element.display.label,
                    0,
                    "",
                    element.conditionFieldNo,
                    element.configId
                  );

                if (element.fieldNo == 4)
                  this.AddAnswer(
                    element.fieldNo,
                    userProfile.email,
                    element.display.inputType,
                    element.display.label,
                    0,
                    "",
                    element.conditionFieldNo,
                    element.configId
                  );
              });
            });
            console.log(this.answerMap);
            this.globalvar.redirectPage(this.currentpage, true, false, true);
          }
        }
        // ,
        // (error: any) => {
        //   if (error.status == "500" || error.status) {
        //     console.log("Login FAild", error.status);
        //   }
      }
    );
  }

  setConfigOptions(configId: string, fieldNo: number) {
    this.configmap.getConfigData(
      configId,
      fieldNo,
      (resp: Array<Searchconfig>) => {
        this.configmap.configMap.set(configId, resp);
      },
      this.globalvar.isTokenLogin
    );
  }

  getSubmissionsDataBYSubmittedId(
    answers: any,
    id: string,
    loadOrganization: boolean
  ) {
    this.apiService.getTop5SubmissionsbyFormFilledId(id, (resp) => {
      if (resp) {
        if (resp.extraData) {
          let data = JSON.parse(resp.extraData);
          this.globalvar.AddWatchList = data;

          if (data?.answerMapCollegeSelections != undefined) {
            let CollegeSelctionList = JSON.parse(
              data?.answerMapCollegeSelections
            );
            this.globalvar.CollegeSelctionList = new Map(CollegeSelctionList);
          }
          if (data?.answerMapCollegeFiltersFilter != undefined) {
            let filterSelected = JSON.parse(
              data?.answerMapCollegeFiltersFilter
            );
            this.globalvar.filterSelected = new Map(filterSelected);
          }
          if (data?.answerMapaffinityQuestionAnswer != undefined) {
            let affinityQuestionAnswer = JSON.parse(
              data?.answerMapaffinityQuestionAnswer
            );

            this.globalvar.affinityQuestionAnswer = new Map(
              affinityQuestionAnswer
            );
          }
          if (data?.answerMapCollegeStateInOutMap != undefined) {
            let stateAnswerModel = JSON.parse(
              data?.answerMapCollegeStateInOutMap
            );
            this.globalvar.stateAnswerModel = new Map(stateAnswerModel);
          }
          if (data?.filterPageCollegeMap != undefined) {
            let filterPageCollegeMap = JSON.parse(data?.filterPageCollegeMap);
            this.globalvar.interestPageAnswerMap = new Map(
              filterPageCollegeMap
            );
          }
          this.globalvar.change(7);
          this.router.navigate(["/home/steps/" + Number(7)]);
          this.isLoading = false;
          this.spinnerService.hide();
        } else {
          const pg = 1;
          this.globalvar.redirectPage(pg, true, false, true);
          this.isLoading = false;
          this.spinnerService.hide();
        }
      }
    });
  }

  getAnswerMapFromID(formFilledId: string) {
    this.apiService
      .getFormFilled(formFilledId)
      .then((response: FormResponse) => {
        const ans = response.answers;
        ans.forEach((element) => {
          // element.configId = "";
          this.answerMap.set(element.fieldNo, element);
        });
        this.globalvar.answerMap = this.answerMap;
        if (this.globalvar.formId != "") {
          this.getPageData();
        }
      });
  }

  getDisabled(qus: Question): boolean {
    const val = this.disableMap.get(qus.fieldNo);
    return val || false;
  }

  pageResponseData(response: any) {
    this.globalvar.formReqData = response;
    this.apiService.formData = response;
    if (response?.filledByInfos.length > 0) {
      this.setDefaultAnswerMap(response.filledByInfos);
    }
    this.apiCall = false;
    const pageid = this.currentpage - 1;
    this.totalpage = response?.pages?.length || 0;
    if (this.currentpage > 0 && response?.pages) {
      // if(this.currentpage==2)
      // {
      // }
      if (response?.pages[pageid]) {
        this.pageData = response?.pages[pageid];
      }
      this.showData = true;
      this.spinnerService.hide();
    } else {
      this.pageData = {} as Page;
    }

    if (this.currentpage == 0 && response?.filledByInfos.length > 0) {
      if (!this.formData) {
        this.formData = response;
        if (this.formData?.filledByInfos) {
          this.calculatedFillebyinfo(this.formData?.filledByInfos);
          // this.isLoading = false;
          this.spinnerService.hide();
        }
      } else {
        this.formData = response;
        if (this.formData?.filledByInfos) {
          this.calculatedFillebyinfo(this.formData?.filledByInfos);
          this.spinnerService.hide();
        }
      }
    }
  }

  getPageData() {
    // this.isLoading = true;
    this.apiCall = true;
    this.spinnerService.show();
    if (this.globalvar.formReqData && this.apiService.formData) {
      this.pageResponseData(this.globalvar.formReqData);
    } else {
      this.apiService.getFormData((response: FormData) => {
        this.globalvar.formReqData = response;
        this.apiService.formData = response;
        this.pageResponseData(response);
      });
    }
  }

  setDefaultAnswerMap(filedbyinfo: Array<Question>) {
    filedbyinfo.forEach((element) => {
      if (element.defaultValue && !this.answerMap.get(element.fieldNo))
        this.AddAnswer(
          element.fieldNo,
          element.defaultValue,
          element.display.inputType,
          element.display.label,
          0,
          "",
          element.conditionFieldNo,
          element.configId
        );
    });
  }

  AddAnswer(
    fieldNo: number,
    value: string,
    type: InputType,
    label: string,
    parentwidgetno: number,
    altValue: string,
    conditionFieldNo: number,
    casePreserve: string,
    configId?: string
  ) {
    // configId
    const data: Answer = {
      fieldNo: fieldNo,
      value: value,
      type: type,
      label: label,
      parentwidgetno: parentwidgetno,
      altValue: altValue,
      configId: configId,
      conditionFieldNo: conditionFieldNo,
      tags: [],
      casePreserve: casePreserve,
    };
    this.changeinputinformfilled(data);
  }

  ngOnChanges() {}

  gotoStep() {
    if (this.isValid) {
      if (this.globalvar.saveChangedDeduct == true) {
        if (this.globalvar.formSubmitId != "") {
          this.apiService.getFormFilledCallBack(
            this.globalvar.formSubmitId,
            (response: FormResponse) => {
              this.globalvar.formResponse = response;
              this.submitFormData();
            }
          );
        } else {
          this.submitFormData();
        }
      } else {
        // const pg =this.currentpage==0?1:2;
        const pg = ++this.currentpage;
        this.globalvar.redirectPage(pg, true, false, true);
        this.globalvar.saveChangedDeduct = true;
      }
    } else {
      this.showError = true;
    }
  }

  submitFormData() {
    this.showError = false;
    this.isLoading = true;
    this.spinnerService.show();
    this.apiService.submitForm(this.answerMap, 0, false, "TOP5", (resp) => {
      let formSubmitId = resp["id"];
      this.globalvar.formSubmitId = formSubmitId;
      this.globalvar.formResponse = resp;
      resp.answers.forEach((element) => {
        this.globalvar.preSelectedAnswerMap.set(element.fieldNo, element);
      });

      const pg = ++this.currentpage;
      // const pg =this.currentpage==0?1:2;
      this.globalvar.redirectPage(pg, true, false, true);
      this.globalvar.saveChangedDeduct = true;
      this.isLoading = false;

      this.spinnerService.hide();
    });
  }

  ngAfterContentChecked(): void {
    this.ChangeDetectorRef.detectChanges();
  }

  FormSubmitData() {
    this.spinnerService.show();
    this.apiService.submitForm(this.answerMap, 0, false, "TOP5", (resp) => {
      let formSubmitId = resp["id"];
      this.globalvar.formSubmitId = formSubmitId;
      this.globalvar.formResponse = resp;

      const pg = ++this.currentpage;
      this.globalvar.change(pg);
      this.isLoading = false;
      this.spinnerService.hide();
    });
  }
  calculatedFillebyinfo(filedbyinfo: Array<Question>) {
    // this.spinnerService.show();

    let array: Array<Question> = [];
    // let dis = false;
    filedbyinfo.forEach((element, index) => {
      if (element?.fieldNo === 265) {
        let conditionExist = false;
        const getAnswerState = this.answerMap.get(6);
        if (getAnswerState) {
          if (
            element.configId !=
            "state_" + getAnswerState?.value + "_county"
          ) {
            element.configId = "state_" + getAnswerState?.value + "_county";
          }
        }
      }

      if (element?.fieldNo == 41) {
        const US_Citizen = this.answerMap.get(41);
        if (US_Citizen) {
          if (US_Citizen.value == "no") {
            this.globalvar.isInternatinalStudent = true;
            this.isInternatinalStudent = true;
            let removeList = [6, 40, 99999];
            removeList.forEach((fieldNo) => {
              this.removeinput(fieldNo);
            });
          } else {
            this.globalvar.isInternatinalStudent = false;
            this.isInternatinalStudent = false;
            this.removeinput(238);
          }
        }
      }
      if (element.fieldNo === 99999) {
        const getAnswerState = this.answerMap.get(6);
        // this.defaultValues=element.defaultValue;
        // const getStateGrant = this.answerMap.get(99999);
        // if (getStateGrant?.value){
        const st = getAnswerState?.value;
        this.configmap.getVirtueConfigData(
          `state_code_link_${st}`,
          8889898,
          (resp) => {
            if (resp.length) {
              element.moreInfo.link = resp[0].value;
              if (resp[0]?.altValue) {
                element.defaultValue = resp[0].altValue;
              } else {
                element.defaultValue = this.defaultValues;
              }
            } else {
              element.defaultValue = this.defaultValues;
              element.moreInfo.link =
                "https://studentaid.gov/help-center/answers/article/state-aid";
            }
          }
        );
        // }
      }

      if (element.fieldNo === 239) {
        const getAnswerState = this.answerMap.get(6);
        let getAnswerCounty = this.answerMap.get(265);
        //check in conditionalvalue
        if (!getAnswerCounty) {
          this.answerMap.forEach((value, key) => {
            if (value.conditionFieldNo === 265) {
              getAnswerCounty = value;
            }
          });
        }

        if (getAnswerCounty) {
          if (
            element.configId != `county_${getAnswerCounty?.altValue}_zipcode`
          ) {
            element.configId = `county_${getAnswerCounty?.altValue}_zipcode`;
          }
        } else if (getAnswerState) {
          if (element.configId != `state_${getAnswerState?.value}_zipcode`) {
            element.configId = `state_${getAnswerState?.value}_zipcode`;
          }
        } else {
        }
      }
      if (element?.visibilityCondition?.visibleType === "SHOWN") {
        const hidden = this.codehelp.checkVisibilityCondition(
          element,
          this.answerMap,
          "SHOWN"
        );
        if (!hidden) {
          array.push(element);
        } else {
          this.removeinput(element.fieldNo);
          this.addFieldasValid(element.fieldNo);
        }
      } else if (element?.visibilityCondition?.visibleType === "HIDDEN") {
        const shown = this.codehelp.checkVisibilityCondition(
          element,
          this.answerMap,
          "SHOWN"
        );
        if (!shown) {
          this.removeinput(element.fieldNo);
          this.addFieldasValid(element.fieldNo);
        } else {
          array.push(element);
        }
      } else {
        array.push(element);
      }
      if (element?.visibilityCondition?.visibleType === "DISABLED") {
        const shown = this.codehelp.checkVisibilityCondition(
          element,
          this.answerMap,
          "DISABLED"
        );
        if (!shown) {
          // disable true add in map
          this.disableMap.set(element?.fieldNo, true);
        } else {
          this.disableMap.set(element?.fieldNo, false);
        }
      }
    });
    this.calculatedFilledbyinfoArray = array;
    this.isLoading = false;
    this.showData = true;
  }

  changeOptionDaat(ev: any) {
    this.opdata = ev;
  }

  addFieldasValid(fieldNo: number) {
    let ev: FieldInfo = {};
    ev[fieldNo] = "valid";
    this.formValid(ev);
  }

  errorInput(error: string) {
    let edata = error.split(":");
    if (edata.length > 0) {
      if (edata[0] == "add" && this.errorMessage.indexOf(edata[1]) == -1) {
        this.errorMessage.push(edata[1]);
      } else if (
        edata[0] == "rem" &&
        this.errorMessage.indexOf(edata[1]) != -1
      ) {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      } else if (edata[0] == "rem" && edata[1] == "") {
        this.errorMessage.splice(this.errorMessage.indexOf(edata[1]), 1);
      }
    }
  }

  checkChangeDeductValue(op: any) {
    if (this.globalvar.preSelectedAnswerMap) {
      let changeAnswer = this.globalvar.preSelectedAnswerMap.get(op.fieldNo);

      if (changeAnswer != undefined) {
        if (Number(changeAnswer.value) != Number(op.value)) {
          this.saveChangeDeduct = true;
          this.globalvar.saveChangedDeduct = true;
        } else {
          this.globalvar.saveChangedDeduct = false;
        }
      } else {
        this.globalvar.saveChangedDeduct = true;
      }
    }
  }

  changeinputinformfilled(op: Answer) {
    if (this.checkUserLogin.CheckUserSession() == false) {
      this.checkUserLogin.onLogout("");
    } else {
      if (op.value) {
        this.checkChangeDeductValue(op);
        this.answerMap.set(op.fieldNo, op);
        this.answerMap = new Map(this.answerMap);
        this.globalvar.answerMap = this.answerMap;
        if (this.formData?.filledByInfos) {
          this.calculatedFillebyinfo(this.formData?.filledByInfos);
        }
      }
    }
  }

  setAllValid() {
    if (this.validated) {
      let _this = this;
      Object.keys(this.validated).forEach(function (key) {
        if (_this.validated && _this.validated[key]) {
          _this.validated[key] = "valid";
        }
      });
    }
  }

  goBack() {
    this.showError = true;
    this.setAllValid();
    const pg = --this.currentpage;
    this.globalvar.redirectPage(pg, true, false, false);
    // this.globalvar.change(pg);
    // this.globalvar.isNotOrganizationLoading(true);
    // // this.globalvar.hanleOrganizationLoading(false);
    // this.router.navigate(["/home/steps/" + Number(pg)]);
    // this.getPageData();
  }

  formValid(ev: FieldInfo) {
    this.validated = { ...this.validated, ...ev };
    let checkvalid = true;
    this.isValid = checkvalid;
    for (const key in this.validated) {
      if (this.validated[key] == "inValid" && checkvalid) {
        checkvalid = false;
        this.isValid = checkvalid;
        return;
      }
    }
  }

  changeWidgetInput(op: Answer) {
    if (op.value) {
      this.checkChangeDeductValue(op);
      this.answerMap.set(op.fieldNo, op);
      this.answerMap = new Map(this.answerMap);
      this.globalvar.answerMap = this.answerMap;
    }
  }

  getConfigId(qus: Question) {
    // return qus.configId;
    if (qus.fieldNo === 239) {
      const getAnswerState = this.answerMap.get(6);
      const getAnswerCounty = this.answerMap.get(265);

      if (getAnswerCounty) {
        if (qus.configId != `county_${getAnswerCounty?.altValue}_zipcode`)
          qus.configId = `county_${getAnswerCounty?.altValue}_zipcode`;
      } else if (getAnswerState) {
        if (qus.configId != `state_${getAnswerState?.value}_zipcode`)
          qus.configId = `state_${getAnswerState?.value}_zipcode`;
      }
    }
    if (qus?.configConditions.length) {
      const condiotionValue = this.codehelp.checkConfigCondition(
        qus?.configConditions,
        this.answerMap,
        ""
      );
      if (condiotionValue) {
        return condiotionValue;
      } else {
        return qus.configId;
      }
    } else {
      return qus.configId;
    }
  }

  getaltValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.altValue || "";
  }

  getValue(qus: Question) {
    const val = this.answerMap.get(qus.fieldNo);
    return val?.value || "";
    // return '';
  }

  removeinput(fieldid: number) {
    this.answerMap.delete(fieldid);
    this.answerMap = new Map(this.answerMap);
  }

  changeUSCitizen(val: boolean) {
    this.isInternatinalStudent = val;
    this.globalvar.isInternatinalStudent = val;
  }

  updateSectionTitle(event: number) {
    switch (event) {
      case 1:
        this.sectionTitle = "Profile";
        this.setHeadercontainer = 1;
        break;
      case 2:
        this.sectionTitle = "Academics";
        this.setHeadercontainer = 2;

        break;
      case 3:
        this.sectionTitle = "Competing Offers";
        this.setHeadercontainer = 3;
        break;
      case 4:
        this.sectionTitle = "Cross-Competitor Comparison";
        this.setHeadercontainer = 4;
        break;
      default:
        this.sectionTitle = "";
        break;
    }
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }

  saveFiles(files: FileList) {
    if (files.length > 1) {
    }
    // this.error = "Only one file at time allow";
    else {
      // this.error = "";
    }
  }

  efcURL() {
    let answerMap = [];
    let filterAnswer = [6, 41];
    filterAnswer.forEach((val) => {
      let ans = this.answerMap.get(val);
      if (ans) {
        answerMap.push(ans);
      }
    });

    let data = {
      virtueEFC: true,
      answerMap: answerMap,
    };

    let efc = "https://tech.virtueanalytics.com/efcApp/EFC/steps/";
    let ecrpy = this.common.setEncrpt(data);
    let decrpt = this.common.getDecriptKeyWithURL(ecrpy);

    return efc + ecrpy;
  }
}
